<template>
  <div>
    <div class="d-flex align-items-center">
      <b-button variant="link" class="ml-auto" pill @click="addNewTier"
                :disabled="excludeKeys.length === template_types.length">
        <font-awesome-icon :icon="'plus-circle'"/>
        {{ $t('New Email Notification Tier') }}
      </b-button>
    </div>
    <div>
      <div class="row mt-2">
        <div class="font-weight-bold col-md-6 pb-2">
          {{ $t('Template Type') }}
        </div>
        <div class="font-weight-bold col-md-5 pb-2">
          {{ $t('Emails') }}
        </div>
        <div class="col-md-1">{{ " " }}</div>
      </div>
      <div class="row" v-for="(tier, index) in model.tiers" :key="`tier-${index}`">
        <div class="col-md-6">
          <div>
            <template-type-select-input-widget :model="tier" attribute="template_type"
                                               @select="onTemplateTypeChange($event, index)"
                                               @unselect="onTemplateUnselect(index)" :label="false"
                                               :rules="'required'" :exclude-keys="excludeKeys"/>
          </div>
        </div>
        <div class="col-md-5">
          <div>
            <input-widget :hint="false" :label="false" :model="tier" attribute="emails" type="tags"
                          :rules="'required|email|max:73'"/>
          </div>
        </div>
        <div class="col-md-1">
          <div class="pl-2">
            <b-tooltip :target="`remove-charge-tier-button-${index}`" :title="$t('Delete')"/>
            <font-awesome-icon class="text-danger hover-cursor"
                               :id="`remove-charge-tier-button-${index}`"
                               @click="removeTierByIndex(index)"
                               style="font-size: 1.5em;margin-top: .2em"
                               :icon="'times'"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import TemplateTypeSelectInputWidget from "../../widgets/TemplateTypeSelectInputWidget";
  import InputWidget from "../input-widget/InputWidget";
  import TemplatesToEmailsModel from "./TemplatesToEmails.model";
  import {createNamespacedHelpers} from "vuex";

  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "CustomerEmailsTiers",
    components: {TemplateTypeSelectInputWidget, InputWidget},
    data() {
      return {}
    },
    props: {
      model: {
        type: Object,
        required: true
      },
    },
    computed: {
      ...globalMapState({
        template_types: state => state.template_types,
      }),
      excludeKeys() {
        //exclude templates with "to" field, templates for account managers and templates that were already used in tiers
        let keys = ['fulcrum_error_log', 'reserve_not_met_notification_for_account_managers', 'sale_finished_notification_for_account_manager', 'shipping_paid_notification', 'webapp_password_reset', 'webapp_email_confirmation', 'webapp_outbid_notification']
        this.model.tiers.forEach(tier => {
          keys.push(tier.template_type);
        })
        return keys;
      }
    },
    methods: {
      onTemplateTypeChange(value, index) {
        this.model.tiers[index].template_type = value.key;
      },
      onTemplateUnselect(index) {
        this.model.tiers[index].template_type = null;
      },
      addNewTier() {
        this.model.tiers.push(new TemplatesToEmailsModel({uuid: null, template_type: null, emails: []}))
      },
      removeTierByIndex(index) {
        for (let i = 0; i < this.model.tiers.length; i++) {
          if (i === index) {
            this.model.tiers.splice(i, 1);
            break;
          }
        }
      },
    },
  }
</script>

<style scoped>

</style>